import { useEffect, useMemo, useRef, useState } from "react";
import {
  GoogleMap,
  MarkerF,
  InfoWindowF,
  useJsApiLoader,
} from "@react-google-maps/api";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import iCar from "../../assets/icons/iCar.png";

const DEFAULT_CENTER = { lat: 47.92, lng: 106.92 };
const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || "";

const Index = (props) => {
  const [form] = Form.useForm();
  const [active, setActive] = useState(null);
  const mapRef = useRef(null);

  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAPS_KEY,
  });

  const handleSearch = (values) => {
    props?.request({
      url: `/sock/location/list`,
      method: "POST",
      body: values,
      model: "allmap",
    });
  };

  const cars = useMemo(
    () =>
      (props?.resallmap || [])
        .filter((item) => item?.lat && item?.lon)
        .map((item) => ({
          ...item,
          position: { lat: Number(item.lat), lng: Number(item.lon) },
        })),
    [props?.resallmap]
  );

  // Хайлтын үр дүн ирэхэд бүх машиныг багтаахаар zoom-лоно
  useEffect(() => {
    if (!isLoaded || !mapRef.current || !cars.length) return;
    if (cars.length === 1) {
      mapRef.current.panTo(cars[0].position);
      mapRef.current.setZoom(16);
      return;
    }
    const bounds = new window.google.maps.LatLngBounds();
    cars.forEach((c) => bounds.extend(c.position));
    mapRef.current.fitBounds(bounds, 60);
  }, [cars, isLoaded]);

  const markerIcon = useMemo(() => {
    if (!isLoaded || !window.google) return undefined;
    return {
      url: iCar,
      scaledSize: new window.google.maps.Size(40, 40),
      anchor: new window.google.maps.Point(20, 20),
    };
  }, [isLoaded]);

  const options = useMemo(
    () => ({
      mapTypeId: "hybrid",
      disableDefaultUI: true,
      zoomControl: true,
      gestureHandling: "greedy",
      clickableIcons: false,
    }),
    []
  );

  return (
    <div className={`w-full h-full flex flex-col`}>
      <Form form={form} layout="inline" onFinish={handleSearch}>
        <Form.Item name="number">
          <Input placeholder="Машины дугаараар хайх" allowClear />
        </Form.Item>
        <Button
          icon={<SearchOutlined />}
          htmlType="submit"
          type="primary"
          loading={props?.isallmap === true}
        >
          Хайх
        </Button>
      </Form>
      <div className="relative w-full h-full mt-2 rounded-xl overflow-hidden">
        {loadError ? (
          <div className="w-full h-full flex items-center justify-center text-sm">
            Газрын зураг ачаалахад алдаа гарлаа.
          </div>
        ) : isLoaded ? (
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "100%" }}
            center={DEFAULT_CENTER}
            zoom={16}
            options={options}
            onLoad={(map) => (mapRef.current = map)}
            onUnmount={() => (mapRef.current = null)}
            onClick={() => setActive(null)}
          >
            {cars.map((item, i) => (
              <MarkerF
                key={item?.imei || item?.number || i}
                position={item.position}
                icon={markerIcon}
                onClick={() => setActive(i)}
              >
                {active === i && (
                  <InfoWindowF
                    position={item.position}
                    onCloseClick={() => setActive(null)}
                  >
                    <div className="text-black">
                      {item?.name} <br /> {item?.number}
                    </div>
                  </InfoWindowF>
                )}
              </MarkerF>
            ))}
          </GoogleMap>
        ) : null}
      </div>
    </div>
  );
};
export default Index;
